import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import './index.css';
import App from './App';

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { SoftUIControllerProvider } from "context";


// Configuration object constructed.
const config = {
    auth: {
        clientId: 'edaeab92-8ceb-4252-a048-75414cdea46c',
        authority: 'https://login.microsoftonline.com/b631cb0e-9f42-4323-8b47-cd6f07832bd8', // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
        redirectUri: 'https://fei-dev.fieldenvironmental.com',
        postLogoutRedirectUri: 'https://fei-dev.fieldenvironmental.com',
        navigateToLoginRequestUrl: true
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: true,
        secureCookies: false
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => { },
            piiLoggingEnabled: false
        },
        windowHashTimeout: 60000,
        iframeHashTimeout: 6000,
        loadFrameTimeout: 0,
        asyncPopups: false
    },
};

// create PublicClientApplication instance
const publicClientApplication = new PublicClientApplication(config);

window.onError = function(e) {
    console.error(e);
    return true;
}

// Wrap your app component tree in the MsalProvider component
ReactDOM.render(
        <React.StrictMode>
            <MsalProvider instance={publicClientApplication}>
                <SoftUIControllerProvider>
                    <BrowserRouter>                    
                        <App />
                    </BrowserRouter>            
                </SoftUIControllerProvider>   
            </MsalProvider>
        </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
